import ImagesSlider from 'assets/core/js/module/imagesSlider'
import { initZoomMediasPanel } from 'assets/core/js/page/product/zoomMediasPanel'

const initProductSlider = (): void => {
  const el = document.querySelector<HTMLElement>('.product__images .slider')

  if (!el) {
    return
  }

  ImagesSlider(
    el,
    {
      loop: false,
      pagination: {
        el: '.slider-pagination',
        type: 'custom',
        renderCustom: function (current: number, total: number) {
          return `${current}/${el.hasAttribute('data-total-images') ? (el.getAttribute('data-total-images') as string) : total}`
        },
      },
      spaceBetween: 10,
    },
    false
  )
}

export default function (): void {
  initProductSlider()

  document.querySelectorAll<HTMLImageElement>('.product__images img').forEach((img) => {
    initZoomMediasPanel(img, true)
  })
}
